import React from 'react';
import { BottomNav } from './BottomNav';
export function MobileLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="w-full min-h-screen bg-ui-card flex justify-center overflow-hidden" data-id="element-94">
      <div className="w-full max-w-[430px] min-h-screen bg-ui-bg relative shadow-2xl flex flex-col overflow-hidden" data-id="element-95">
        <div className="flex-1 overflow-y-auto overflow-x-hidden no-scrollbar pb-16" data-id="element-96">
          {children}
        </div>
        <BottomNav data-id="element-97" />
      </div>
    </div>;
}